<script setup>
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import RemoteImage from '@/components/general/BaseRemoteImage.vue'
import { useCategoriesStore } from '@/stores/CategoriesStore'

const categoriesStore = useCategoriesStore()

const { getProductsCategories } = storeToRefs(categoriesStore)

const props = defineProps({
  categoriesArray: {
    type: Array,
    required: true,
  },
})

const categories = computed(() =>
  props.categoriesArray.length > 0 ? props.categoriesArray : getProductsCategories.value.filter(cat => cat.subcategories.length > 0).slice(0, 5)
)
</script>

<template>
  <ul
    v-if="categories.length > 0"
    class="list-unstyled mb-0 search-category-list flex flex-col"
  >
    <li
      v-for="(category, index) in categories"
      :key="index"
      class="flex px-0"
    >
      <router-link
        v-close-popper
        :to="{ name: 'productsPath', params: { permalink: category.permalink } }"
        class="rounded-lg flex flex-row bg-white no-decoration text-primary"
      >
        <div class="category-item flex flex-row items-center flex-grow-1 items-center py-1 px-3 text-sm font-semi-bold">
          <div class="category-icon mr-1">
            <RemoteImage
              :src="`https://img.mix.it/general_assets/categories/${category.image}`"
              img-class="w-100"
              :alt="category.title"
            />
          </div>
          {{ category.title }}
        </div>
      </router-link>
    </li>
  </ul>
</template>

<style lang="scss">
.search-category-list {
    gap: 12px;
    .category-item {
        .category-icon {
            width: 32px;
        }
    }
}
</style>